/*
 * SS-CUSTOM: pack helper
 * Converts a floor size to a pack count in the PDP buy box.
 *
 * Whole tiles along each side of each area, so a tile cut at a wall counts
 * whole; the areas' tiles are added, then rounded up to full packs. Sizes go
 * to whole millimetres before any division, so 6 m is 15 tiles of 400 mm,
 * never 16. No allowance is added, so the number always reconciles with what
 * lands in the cart. Applying it writes the count into the quantity input,
 * collapses the helper and flashes the box, because a silent value change
 * reads as a broken button.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-ss-packhelp]');
  if (!root) return;

  var areas = root.querySelectorAll('[data-ss-packhelp-area]');
  var add = root.querySelector('[data-ss-packhelp-add]');
  var out = root.querySelector('[data-ss-packhelp-out]');
  var apply = root.querySelector('[data-ss-packhelp-apply]');
  if (!areas.length || !out || !apply) return;

  var tileLength = parseInt(root.dataset.tileLength, 10);
  var tileWidth = parseInt(root.dataset.tileWidth, 10);
  var packTiles = parseInt(root.dataset.packTiles, 10);
  if (!tileLength || !tileWidth || !packTiles) return;

  function quantityInput() {
    // the main buy box, not the sticky bar or a quick-add card
    return document.querySelector(
      '.product-form__quantity input[name="quantity"], product-info input[name="quantity"]'
    );
  }

  function mm(input) {
    return Math.round((parseFloat(input.value) || 0) * 1000);
  }

  // a long tile is laid the way that takes fewer
  function tilesFor(area) {
    var width = mm(area.querySelector('[data-ss-packhelp-width]'));
    var length = mm(area.querySelector('[data-ss-packhelp-length]'));
    if (width <= 0 || length <= 0) return 0;
    return Math.min(
      Math.ceil(width / tileWidth) * Math.ceil(length / tileLength),
      Math.ceil(width / tileLength) * Math.ceil(length / tileWidth)
    );
  }

  function packsFor() {
    var tiles = 0;
    areas.forEach(function (area) {
      if (!area.hidden) tiles += tilesFor(area);
    });
    return { tiles: tiles, packs: Math.ceil(tiles / packTiles) };
  }

  function render() {
    var result = packsFor();
    if (result.tiles <= 0) {
      out.textContent = '';
      apply.hidden = true;
      return;
    }

    apply.hidden = false;
    apply.textContent = 'Use ' + result.packs + (result.packs === 1 ? ' pack' : ' packs');
    out.innerHTML =
      result.tiles +
      ' tiles → <b>' +
      result.packs +
      (result.packs === 1 ? ' pack</b>' : ' packs</b>');
  }

  apply.addEventListener('click', function () {
    var input = quantityInput();
    if (!input) return;

    input.value = packsFor().packs;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));

    var details = apply.closest('details');
    if (details) details.open = false;

    var box = input.closest('quantity-input') || input;
    box.classList.add('ss-qty-applied');
    box.scrollIntoView({ block: 'center', behavior: 'smooth' });
    setTimeout(function () {
      box.classList.remove('ss-qty-applied');
    }, 1800);
  });

  if (add) {
    add.addEventListener('click', function () {
      var next = root.querySelector('[data-ss-packhelp-area][hidden]');
      if (!next) return;
      next.hidden = false;
      next.querySelector('input').focus();
      add.hidden = !root.querySelector('[data-ss-packhelp-area][hidden]');
      render();
    });
  }

  root.querySelectorAll('[data-ss-packhelp-remove]').forEach(function (button) {
    button.addEventListener('click', function () {
      var area = button.closest('[data-ss-packhelp-area]');
      area.hidden = true;
      area.querySelectorAll('input').forEach(function (input) {
        input.value = '';
      });
      if (add) {
        add.hidden = false;
        add.focus();
      }
      render();
    });
  });

  root.querySelectorAll('[data-ss-packhelp-width], [data-ss-packhelp-length]').forEach(function (input) {
    input.addEventListener('input', render);
  });
  render();
})();
